import {util} from '../../service/util'
import options from '../../service/data.options'
let API = util.api([
    // 登录
    'GETCUSTOMERINFO', // 获取用户信息

    // 订单
    'FINDMYORDER', // 查询订单
    'SINGLECREATEORDER',// 创建普通订单
    'IMPROPERCREATEORDER', // 特殊订单
    'FINDMYAUDITION', // 查询试音
    'GETCONTRIBUTIONBYID',//id查询稿件
    'GETSTATISTICSBYCUSTOMERSEARCH',//合计
    'WAITERADDINVOICEAPPLY', // 客户根据订单开票

    /* 收藏 */
    'SIGNIN',
    'SEARCHPAYRECORD',  //支付记录
    'GETINFOCOUNT', // 未读消息条数
  ]);

const state = {
  /**
   * 用户信息
   */
  log: '',
  userInfo: {},
  isSingin: false,
  amount: 0, // 未读消息
  options: options,
  /**
   * 缓存的声音数据
   */
  soundData: {},
  playingItem: {

  },

  /**
   * 选中待支付的订单，支付时需要
   */
  payOrders: [],
  /**
   * 选中待开票的订单，开票时需要
   */
  invoiceOrders: [],
  /**
   * 选中代开票的支付记录，开票时需要
   */
  invoicePays: [],
}

const mutations = {
  GETUSERINFO(state, payload) {
    window.USERINFO = payload.data;
    state.userInfo = payload.data;
  },
  SIGNIN(state, payload) {
    state.isSingin = true;
  },
  LOG(state, data) {
    state.log = data;
  },
  SOUNDDATA(state, payload) {
    state.soundData = { ...state.soundData, ...payload };
  },
  PAYORDERS(state, data) {
    state.payOrders = data;
  },
  INVOICEORDERS(state, data) {
    state.invoiceOrders = data;
  },
  INVOICEPAYS(state, data) {
    state.invoicePays = data;
  },
  AMOUNT(state, data) {
    state.amount = data||0;
  }
}

const actions = {
  // log
  log({commit, state}, log) {
    commit('LOG', log);
  },

  /**
   * 获取用户信息
   */
  getUserInfo({commit, state}) {
    return new Promise((resolve, reject) => {
      util.kAjax(API.GETCUSTOMERINFO, {}, json => {
        let res = {
          type: 'GETUSERINFO',
          data: json.data
        }
        // cookie,用户信息
        util.cookie.set('userName',res.data.userPetname || '深度会员');
        util.cookie.set('userHead',res.data.userHead);
        util.cookie.set('baseId',res.data.baseId);
        util.setCollectCookie(res.data.collectMap);
        util.getCollectCookie();
        commit(res);
        resolve(res);
      })
    })
  },
  /**
   * 获取用户订单
   */
  getOrderList({commit, state}, param) {
    return new Promise((resolve) => {
      util.kAjax(API.FINDMYORDER, param, json => {
        let res = {
          type: 'GETORDERLIST',
          data: json.data
        }
        resolve(res);
      })
    })
  },
  
  /**
   * 签到
   */
  signin({commit, state}) {
    return new Promise( resolve => {
      util.kAjax(API.SIGNIN, {}, json => {
        let res = {
          type: 'SIGNIN',
          data: json.data
        };
        resolve(res);
      })
    })
  },


  /**
   * 缓存声音数据
   */
  addSoundData({ commit, state }, datas) {
    let data = {};
    datas.forEach(d => {
      data[d.voiceId] = {  id    : d.voiceId,
                          audio : d.filePath,
                          img   : d.deployDubbing ? d.deployDubbing.dubbingHead : '',
                          dubbingName: d.nameExternal,
                          dubbingId: d.dubbingId,
                          title : d.voiceTitle }
    })
    commit('SOUNDDATA', data);
  },
  /**
   * 获取消息数量
   */
  updateMessageAmount({ commit, state } ) {
    let id = state.userInfo.baseId;
    if(id){
      util.kAjax(API.GETINFOCOUNT, { userId: id }, json => {
        commit('AMOUNT', json.data||0);
      })
    }
  }
}

export default {
  state,
  mutations,
  actions
}


// WEBPACK FOOTER //
// ./src/store/modules/common.js